module.exports = __webpack_public_path__ + "img/food5.71c006ab.png";